const corporateGovernanceSchemeNode = document.querySelector(
    '.js-corporate-governance-scheme'
);

class CorporateGovernanceScheme {
    constructor(container) {
        this.container = container;
        this.blocks = this.container.querySelectorAll(
            '.js-corporate-governance-scheme-block'
        );
        this.textEl = '.corporate-governance__scheme-block-text';
        this.isTouch = $('html').hasClass('bx-touch');
        this.eventType = 'click';
        this.timeoutId;
    }

    init() {
        let self = this;
        $(this.blocks).on(this.eventType, e => {
            self.handleEvent(e);
        })
    }

    handleEvent(e) {
        const $target = $(e.currentTarget);
        const $targetText = $target.children(this.textEl);

        $target.toggleClass('active');
        $targetText.stop().slideToggle(300);
    }
}

if ($(corporateGovernanceSchemeNode).length > 0) {
    new CorporateGovernanceScheme(corporateGovernanceSchemeNode).init();
}



// WEBPACK FOOTER //
// ./frontend/components/corporate-governance/corporate-governance.js